export const projects = [
  {
    id: 1,
    title: "Cordova Calculator",
    image:
      "https://user-images.githubusercontent.com/59008917/185378396-01630ee9-b524-43dd-9d43-bf9b30641721.jpg",
    code: "https://github.com/SaishJ/All-In-One-Calculator-Cordova-",
    live: "https://github.com/SaishJ/All-In-One-Calculator-Cordova-",
  },
  {
    id: 2,
    title: "React Native Chat Application",
    image:
      "https://user-images.githubusercontent.com/59008917/185378411-e7f78b46-1979-442e-b455-1fe5c3970a12.png",
    code: "https://github.com/SaishJ/ReactNative-ChatApp",
    live: "https://github.com/SaishJ/ReactNative-ChatApp/blob/master/android/app/build/outputs/apk/release/app-release.apk",
  },
  {
    id: 3,
    title: "Rupesh Lights",
    image:
      "https://user-images.githubusercontent.com/59008917/195822494-db25e4ea-a929-4df7-99b5-b59715ccdcb9.png",
    code: "https://github.com/SaishJ/RupeshLights",
    live: "https://rupeshlights.netlify.app/",
  },
  {
    id: 4,
    title: "Delicious",
    image:
      "https://github.com/user-attachments/assets/3e4bbf3a-2495-4dd8-92cf-c9a16c2670d5",
    code: "https://github.com/SaishJ/Deliciouss-React-Recipe-App",
    live: "https://delicious-sj.netlify.app/",
  },
  {
    id: 5,
    title: "ASA Gats",
    image:
      "https://github.com/user-attachments/assets/3239afb3-ad2a-4f64-a3e4-60c123fd1e15",
    code: "https://github.com/SaishJ",
    live: "https://asa-gats.netlify.app/",
  },
  {
    id: 6,
    title: "Movie Recommendation System",
    image:
      "https://github.com/user-attachments/assets/027ca6dc-9233-4694-85fb-03f5ce706a1b",
    code: "https://github.com/SaishJ/Movie-Recommendation-System",
    live: "https://saishj.netlify.app/",
  },
];
